module.exports = __webpack_public_path__ + "static/media/Icon-search.6e804ce7.png";